import { FontSizes, FontWeights, NeutralColors, mergeStyleSets } from "@fluentui/react";

export const textStyles = mergeStyleSets({
  textColorGray160: {
    color: NeutralColors.gray160,
    fontFamily: "Microsoft YaHei UI",
    fontSize: FontSizes.size14,
    fontStyle: "normal",
    lineHeight: "20px!important",
  },
  textDisabled: {
    color: NeutralColors.gray120,
    fontFamily: "Microsoft YaHei UI",
    fontSize: FontSizes.size14,
    fontStyle: "normal",
    lineHeight: 20,
  },
  textGray160FS16: {
    color: NeutralColors.gray160,
    fontFamily: "Segoe UI",
    fontSize: FontSizes.size16,
    fontStyle: "normal",
    lineHeight: 22,
    fontWeight: FontWeights.bold,
    padding: "12px 0 24px 0"
  },
  text10Bold: {
    color: NeutralColors.white,
    textAlign: "center",
    fontFamily: "Microsoft YaHei UI",
    fontSize: 10,
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: 14 /* 140% */
  },
  text160Bold: {
    color: NeutralColors.gray160,
    textAlign: "center",
    fontFamily: "Microsoft YaHei UI",
    fontSize: 10,
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: 14 /* 140% */
  },
  textGray120: {
    color: NeutralColors.gray120,
    fontSize: FontSizes.size12,
    fontStyle: "normal",
    fontWeight: FontWeights.regular,
    lineHeight: "16px",
  },
  textGray160: {
    color: NeutralColors.gray160,
    fontSize: FontSizes.size12,
    fontStyle: "normal",
    fontWeight: FontWeights.regular,
    lineHeight: "16px",
  },
  fontSize24: {
    fontSize: FontSizes.size24,
  },
  lineHeight32: {
    lineHeight: 32
  },
  textBold: {
    fontWeight: FontWeights.bold,
    ":after": {
      paddingRight: 0
    }
  },
  textRegular: {
    fontWeight: FontWeights.regular,
  },
  testBold: {
    fontWeight: FontWeights.bold,
  },
  textColorGray130: {
    color: NeutralColors.gray130,
  },
  unauthorized: {
    color: "#D13438",
    fontSize: FontSizes.size12,
    fontFamily: "Microsoft YaHei UI",
    fontWeight: FontWeights.regular,
    lineHeight: FontSizes.size16,
    wordWrap: "break-word"
  },
  authorized: {
    color: NeutralColors.gray160,
    fontSize: FontSizes.size12,
    fontFamily: "Microsoft YaHei UI",
    fontWeight: FontWeights.regular,
    lineHeight: FontSizes.size16,
    wordWrap: "break-word"
  },
  fontSize12: {
    fontSize: FontSizes.size12,
  },
  disabledLinkStyle: {
    // 删除
    color: "#323130",
    fontSize: FontSizes.size12,
    fontFamily: "Microsoft YaHei UI",
    fontWeight: 400,
    lineHeight: 16,
    wordWwrap: "break-word",
    "&:hover": {
      color: "#323130",
    }
  },
  textDescriptionStyle: {
    fontSize: FontSizes.size12,
    fontWeight: 400,
    lineHeight: 16,
    letterSpacing: "0em",
    textAlign: "left",
    color: "#737271",
    whiteSpace: "pre-line"
  },
  headerTitleStyle: {
    fontSize: "20px!important",
    fontWeight: "400px!important",
    // lineHeight: 56,
    letterSpacing: "0em",
    textAlign: "left",
    color: "#323130!important",
  },
  headerTitleStyleWhite: {
    fontSize: 12,
    fontWeight: 400,
    lineHeight: 16,
    textAlign: "left",
    color: "#fff"
  },
  errorMessage: {
    fontSize: FontSizes.size12,
    fontWeight: 400,
    color: "rgb(164, 38, 44)",
    wordBreak: "break-all"
  },
  tipHaderTitle: {
    fontSize: 12,
    fontWeight: 700,
    lineHeight: 16,
    textAlign: "left",
    color: NeutralColors.gray160,
  },
  infoMessage: {
    fontSize: FontSizes.size12,
    fontWeight: 400,
    color: "#737271",
    wordBreak: "break-all"
  },
  orange: {
    color: "#DA3B01"

  },
  wordWrap: {
    wordWrap: "break-word"
  }
});
